/**
 * Enum to reducer action types
 */
enum ActionTypeEnum {
  FAILED = 'FAILED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
}

export default ActionTypeEnum;
